<template>
  <div class="container-cidades">
    <br>
    <div class="row">
       <h4 class="col-sm-12">Contato</h4>


<form v-if="mostrarConteudo" class="row" style="padding:20px;" method="POST" ref="formulario" @submit.prevent.stop="add">

          <div class="form-group col-sm-4">
          <label>Nome:</label>
          <input type="text" name="nome" class="form-control" v-model="nome" />
        </div>

        <div class="form-group col-sm-4">
          <label>E-mail:</label>
          <input type="email" name="email" class="form-control"  v-model="email"/>
        </div>

        <div class="form-group col-sm-4">
          <label>Telefone:</label>
          <input type="text" name="telefone" class="form-control" v-model="telefone" />
        </div>

        <div class="form-group col-sm-12">
          <label>Observações:</label>
          <textarea  name="observacao" class="form-control" v-model="observacao"></textarea>
        </div>

         <div ref="obsTxt" class="form-group col-sm-12">
          <label>Observações Adicionais:</label>
          <textarea  name="observacaoAdicional" ref="obs" class="form-control" v-model="observacaoAdicional"></textarea>
        </div>

        

          <button  type="submit" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">ATUALIZAR</button>

</form>
          

        <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>



         <h4 v-if="mostrarCaptacao" style="margin-top:20px;" class="col-sm-12">Captadores:<br><p>Última atualização: {{dataCaptacao}}</p><hr></h4>

          <div v-if="mostrarCaptacao" class="form-group col-sm-4">
          <label>Principal:</label>
            <select class="form-control" name="cap1" v-model="captadorPrincipal">
            <option value="">Em aberto</option>
            <option v-for="user in usuarios" :key="user.LOG_ID" :value="user.LOG_NOME">{{user.LOG_NOME}}</option>
            </select>
        </div>

        <div v-if="mostrarCaptacao" class="form-group col-sm-4">
          <label>Secundários:</label>
            <select class="form-control" name="cap2" v-model="captadorSecundario" @change="addSecundario">
            <option value="">Selecione</option>
            <option v-for="user in usuarios" :key="user.LOG_ID" :value="user.LOG_NOME" >{{user.LOG_NOME}}</option>
            </select>
        </div>

        <ul v-if="mostrarCaptacao" class="col-sm-4">
          <li v-for="(item,index) in secundariosLista" :key="item">{{item}} <span @click="secundariosLista.splice(index, 1)" class="badge badge-danger" style="cursor:pointer;">X</span></li>
        </ul>

        <button v-if="mostrarCaptacao"  type="submit" class="btn btn-warning col-sm-3" @click="atualizarCaptacao" style="max-height:40px;margin-top:50px;margin:0 auto;">ATUALIZAR CAPTAÇÃO</button>

<br><br>
    </div><!-- row -->


    <div class="row">

      <div v-if="showStatus" class="alert alert-info col-sm-12" role="alert">
       Informações atualizadas com sucesso!
       </div>
    


    </div><!-- row cards -->



  </div>
</template>

<script>
import axios from 'axios'


export default {
  name: 'Contato',
  components: {},
  props:['imovel'],
  data(){
      return {
          mostrarConteudo:true,
           mostrarCaptacao:true,
          observacaoAdicional:"",
          nome:'',
          email:'',
          telefone:'',
          observacao:'',
          showStatus:false,
          captadorPrincipal:'',
          captadorSecundario:'',
          usuarios:[],
          secundariosLista:[],
          dataCaptacao:null,
          loading: false
         
      }
  },
 

methods:{
  getPermissao(){
    return  sessionStorage.getItem('imobiliaria');
  },
   getUsuario(){
       return sessionStorage.getItem('imobiliariaNome');
     },
    add(){
          this.loading = true;
          let fm = new FormData(this.$refs["formulario"]);
          fm.append('id',this.imovel);

          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/updateContato',fm)
          .then(() => {this.get();this.showStatus = true;})
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
      },

   
    get(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getImovel',{imovel:this.imovel})
          .then(response => this.updateInfo(response.data))
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

   
    
    updateInfo(data){
      this.nome = data.IM_NOME_CONTATO;
      this.email = data.IM_EMAIL;
      this.telefone = data.IM_TELEFONE;
      this.observacao = data.IM_OBSERVACAO_CONTATO;
      this.captadorPrincipal = (data.IM_CAPTADOR != null) ? data.IM_CAPTADOR : '';
      this.secundariosLista = (data.IM_CAPTADOR_SEC != null) ? data.IM_CAPTADOR_SEC.split(',') : [];
      this.dataCaptacao = data.IM_DATA_CAPTACAO;
      this.observacaoAdicional = data.IM_OBSERVACAO_PRIVADA;

     if(this.getPermissao() == 4 && this.getUsuario() !=  this.captadorPrincipal){
       this.mostrarConteudo = false;
        this.mostrarCaptacao = false;
      }
      /* if(this.getPermissao() == 3){
       this.mostrarConteudo = false;
        this.mostrarCaptacao = true;
      }*/
    
      
    },
     getUsuarios(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getUsuarios',{})
          .then(response => this.usuarios = response.data)
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    addSecundario(){
      if(this.captadorSecundario != ''){
        this.secundariosLista.push(this.captadorSecundario);
        this.captadorSecundario = '';
      }
      
    },
    atualizarCaptacao(){
       this.loading = true;
          let fm = new FormData();
          fm.append('id',this.imovel);
          fm.append('principal',this.captadorPrincipal);
          fm.append('secundario',this.secundariosLista);


          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/updateCaptacao',fm)
          .then(() => {this.get();this.showStatus = true;})
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    }

  

},
  
  mounted () {
    if(this.getPermissao() > 2){
      this.$refs['obsTxt'].style.visibility = 'hidden';
    this.$refs['obs'].style.visibility = 'hidden';
    }
  this.get();
  this.getUsuarios();
  }



}
</script>